import { render } from "./DocumentRecentlyUpload.vue?vue&type=template&id=36487b44"
import script from "./DocumentRecentlyUpload.vue?vue&type=script&lang=js"
export * from "./DocumentRecentlyUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__